var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLoyaltyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 7L18.4634 20.0831L8 24.6818L18.8103 28.576L21.2581 41L28.5971 30.7198L40 33.2612L33.6608 21.8119L39.2803 12.7398L28.9591 15.9662L18.625 7Z",
    fill: "#FEE5D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoyaltyWhite);
export default __webpack_public_path__ + "static/media/icon-loyalty-white.d65bb5dc4236984daa5a1d422db2c031.svg";
export { ForwardRef as ReactComponent };